import axios from 'axios';
import { sort_center_api } from '@shared/api';
import { ManualWeight } from '@shared/types/parcel';
import {
  ParcelAcceptanceRequest,
  ParcelAcceptanceResponse,
  ParcelChangeDimensionsRequest,
  ParcelChangeWeightRequest,
  ParcelDimensions,
} from '../model/consolidator';

export const getWeight = async (signal?: AbortSignal) => {
  const url = 'http://localhost:7887/';
  let res = null;
  try {
    res = await sort_center_api.get<ManualWeight>(url, { signal });
  } catch (error) {
    res = null;
  }
  return res?.data;
};

export async function acceptance(data: ParcelAcceptanceRequest): Promise<ParcelAcceptanceResponse> {
  const url = 'v1/parcels/acceptance';
  const result = await sort_center_api.post<ParcelAcceptanceResponse>(url, data);
  return result.data;
}

/**
 * Что сервис весов подпишет на кадре (трек, вес, габариты в углу фото — как DWS-комплекс).
 * Оба поля необязательны: чего нет, того на фото не будет, как и самого фото без камеры.
 */
export interface PhotoStamp {
  /** Учтённый вес, г */
  weight?: number | null;
  /** Габариты в см, как в acceptance; сервису весов уходят в мм */
  dimensions?: ParcelDimensions | null;
}

const cmToMm = (size: ParcelDimensions['length']) => Math.round(size.value * 10 * 100) / 100;

/** Query-параметры подписи. Габариты — только все три и положительные, иначе строка запутает. */
function toStampParams(stamp?: PhotoStamp): Record<string, number> {
  const params: Record<string, number> = {};
  if (stamp?.weight != null && Number.isFinite(stamp.weight) && stamp.weight > 0) {
    params.weight = Math.round(stamp.weight);
  }
  const d = stamp?.dimensions;
  if (d && [d.length, d.width, d.height].every((s) => Number.isFinite(s?.value) && s.value > 0)) {
    params.length = cmToMm(d.length);
    params.width = cmToMm(d.width);
    params.height = cmToMm(d.height);
  }
  return params;
}

// Фото отправляется бинарником, поэтому через чистый axios — интерсептор sort_center_api перетирает Content-Type на json
export async function uploadPhoto(trackNumber: string, photoDataUrl: string, stamp?: PhotoStamp) {
  const url = 'http://localhost:7887/photo';
  const blob = await (await fetch(photoDataUrl)).blob();
  await axios.post(url, blob, {
    params: { name: trackNumber, ...toStampParams(stamp) },
    // Тип берём из самого снимка (PNG) — сервис весов по нему подбирает расширение файла
    headers: { 'Content-Type': blob.type || 'image/png' },
  });
}

export async function sendParcelWeight(data: ParcelChangeWeightRequest): Promise<ParcelAcceptanceResponse> {
  const url = 'v1/parcels/change-weight';
  const result = await sort_center_api.post<ParcelAcceptanceResponse>(url, data);
  return result.data;
}

export async function sendParcelDimensions(data: ParcelChangeDimensionsRequest) {
  const url = 'v1/parcels/change-dimensions';
  await sort_center_api.post(url, data);
}
